<script>
    import { scale } from 'svelte/transition';
    import Replacer from "./util/Replacer.svelte";

    let alternatives = [
        "Neinsience•Ligibiery",
        "Nurnurnars•Leraburturery",
        "N-n-scincis•Libritury",
        "Non-sense•Laborbotory",
        "Snosses•Laborse",
        "Tnonsests•Laporatey",
        "Mfomffombff•Pfafforpfy",
        "Narksank•Laoraksay",
        "Kae-kazake•Lagaxaugheig"
    ];

</script>

<style>
.container {
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
}
.blurb {
    width: 40em;
    display: flex;
    flex-direction: column;
}
.blurb h1 {
    font-size: 1.5em;
    margin-bottom: 0.25em;
}

.cta, .cta:hover {
    text-decoration: none;
    color: black;
}

.standalone {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
}

.standalone label {
    margin: 0 0 0 0.5rem;
    font-weight: normal;
    letter-spacing: 0.05rem;
    cursor: pointer;
    pointer-events: none;
}

</style>

<div class="container" transition:scale|local>
    <div class="blurb box light lev0">
        <h1><Replacer content="Nonsense•Laboratory" alternatives={alternatives} /></h1>
        <p><b>What does spelling sound like?</b> The Nonsense Laboratory uses
            machine learning to let you poke at, mangle, curate,
            compress and elaborate the sounds of words spelled in text.
        </p>
        <a class="box dark large cta lev1 standalone" href="#/menu">
            <button id="nonsense" class="action-button orange hovery">&nbsp;</button>
            <label for="nonsense">MAKE NONSENSE</label>
        </a>
    </div>
</div>